import { requestJson } from "./instateamEmployeeApi";

export function getEmployeeAnnouncements(token) {
  return requestJson("/instateam/announcements/employee", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function markAnnouncementRead(token, announcementId, acknowledge = false) {
  return requestJson(`/instateam/announcements/employee/${announcementId}/read`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ acknowledge }),
  });
}
